export default __webpack_public_path__ + "static/media/plain-sticker-H.6e9b8d28.png";